import { getFirstTabPath, permittedTabs } from "@/components/Drawer/data";
import { USER_TYPE } from "@/constants";
import { useUserContext } from "@/context/UserContext";
import routes from "@/routes";
import { useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import RegistrationForm from "./RegistrationForm";
import RoleSelection from "./RoleSelection";

export default function Register() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { user, isAuthenticated } = useUserContext();

  // Get registration type from URL params
  const urlType = searchParams.get("type");
  const isValidType = urlType === "advertiser";
  const registrationType = isValidType ? urlType : null;

  const [step, setStep] = useState<"roleSelection" | "registrationForm">(
    registrationType ? "registrationForm" : "roleSelection"
  );

  if (isAuthenticated) {
    const tabs =
      user &&
      permittedTabs(
        user?.Role?.$permissions,
        user?.Role?.name === USER_TYPE.SUPER_ADMIN
      );
    return <Navigate to={routes.DASHBOARD + "/" + getFirstTabPath(tabs)} />;
  }

  const handleRoleSelection = (role: "advertiser" | "agency") => {
    if (role === "agency") return;
    setSearchParams({ type: role });
    setStep("registrationForm");
  };

  const handleBackToSelection = () => {
    setSearchParams({});
    setStep("roleSelection");
  };

  if (step === "roleSelection") {
    return <RoleSelection onRoleSelect={handleRoleSelection} />;
  }

  // If we're at the registration form step but don't have a valid type, go back to selection
  if (!registrationType) {
    return <RoleSelection onRoleSelect={handleRoleSelection} />;
  }

  return (
    <RegistrationForm
      registrationType={registrationType}
      onBack={handleBackToSelection}
    />
  );
}
